<template>
    <q-icon
        name="fal fa-calendar"
        class="cursor-pointer"
    >
        <q-popup-proxy
            ref="dateProxy"
            cover
        >
            <q-date
                :model-value="value"
                :mask="dateFormat"
                :options="filterFunc"
                color="eidTrustGreen"
                @update:model-value="onDateSelect"
            >
                <div class="row items-center justify-end">
                    <NewButton
                        v-close-popup
                        type="link"
                    >
                        Close
                    </NewButton>
                </div>
            </q-date>
        </q-popup-proxy>
    </q-icon>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { QIcon, QPopupProxy, QDate } from 'quasar';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'DateInputCalendar',
        components: { QIcon, QPopupProxy, QDate, NewButton },
        props: {
            value: {
                type: String as PropType<string>,
                default: '',
            },
            dateFormat: {
                type: String as PropType<string>,
                default: 'M/D/YYYY',
            },
            filterFunc: {
                type: Function as PropType<(date: string) => boolean>,
                default: undefined,
            },
        },
        emits: [ 'input' ],
        methods: {
            onDateSelect(this: any, date: string): void {
                this.$emit('input', date);
                // Close the popup proxy
                const dateProxy = this.$refs.dateProxy as any;
                if (dateProxy && dateProxy.hide) {
                    dateProxy.hide();
                }
            },
        },
    });
</script>
